export default __webpack_public_path__ + "static/media/main_large.4eefd813.png";